import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-platform-onboarding-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './platform-onboarding-modal.component.html',
  styleUrls: ['./platform-onboarding-modal.component.scss']
})
export class PlatformOnboardingModalComponent {

  constructor(public activeModal: NgbActiveModal) {}
}
